const MK = {
  ibanLength: 19,
};
export { MK };
